var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "64px",
    height: "64px",
    viewBox: "0 0 32.00 32.00",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#fffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 0.512
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.896 13.401c-0.245-0.213-0.615-0.308-1.125-0.308h-0.771l0.027 3.256 0.052 3.265 0.749-0.027c0.547 0 0.839-0.093 1.104-0.348 0.323-0.319 0.349-0.48 0.349-2.933 0-2.547-0.027-2.613-0.385-2.905zM0 6.588v18.824h32v-18.824zM11.412 20.401c-0.584 0.771-1.412 1.025-3.371 1.025h-1.76v-10.052h1.864c2.229 0 2.881 0.24 3.469 1.199 0.359 0.572 0.385 0.801 0.427 3.427 0.063 2.973-0.025 3.64-0.629 4.401zM18.197 13.104h-3.291v2.365h2.025v1.703l-0.959 0.057-1 0.036v2.36l1.625 0.041 1.599 0.052v1.708h-2.129c-2.041 0-2.136-0.015-2.495-0.4l-0.401-0.376v-4.213c0-4.025 0.016-4.24 0.333-4.635 0.307-0.417 0.333-0.417 2.511-0.417h2.181v1.735zM24.437 20.375c-0.224 0.573-0.849 1.052-1.333 1.052-0.24 0-0.599-0.197-0.891-0.52-0.427-0.428-0.599-0.839-1.093-2.771l-1.199-4.521-0.604-2.229h1.016c0.531 0 1 0.027 1 0.068 0 0.077 1.547 6.052 1.683 6.443 0.052 0.197 0.421-0.937 0.968-3.068l0.88-3.359 0.991-0.057c0.531-0.027 0.973 0 0.973 0.057 0 0.181-2.229 8.504-2.401 8.905z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.72485009fa91ce4043217b3af333d54b.svg";
export { ForwardRef as ReactComponent };